/* eslint-disable i18next/no-literal-string */
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import Modal from "react-modal"
import "react-phone-number-input/style.css"
import "react-toastify/dist/ReactToastify.css"
import styled from "styled-components"
import { initI18next } from "./01_technical/translations"
import { App } from "./App"
import "./index-reset.css"
import "./index.css"
import { DataDogRum } from "./01_technical/rum"
import { ErrorBoundary } from "@datadog/browser-rum-react"

initI18next()

Modal.setAppElement("#root")

const FatalErrorContainer = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  height: 100%;
  width: 100%;
  font-family: Inter;
`

const container = document.getElementById("root")

if (!container) {
  throw new Error("No root element found")
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary
      fallback={() => (
        <FatalErrorContainer>
          <div lang="en">Please Refresh the page.</div>
          <div lang="fr">Veuillez rafraîchir la page.</div>
          <div lang="es">Actualice la página.</div>
          <div lang="it">Si prega di aggiornare la pagina.</div>
          <div lang="de">Bitte laden Sie die Seite neu.</div>
        </FatalErrorContainer>
      )}
    >
      <DataDogRum />
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
